<script lang="ts">
  import { t } from '../../lib/i18n/index.svelte.js'

  interface Props {
    checked: number
    total: number
  }
  const { checked, total }: Props = $props()
  const percent = $derived(total === 0 ? 0 : Math.round((checked / total) * 100))
  const done = $derived(total > 0 && checked === total)
</script>

{#if total > 0}
  <div class="progress" class:done>
    <span class="label">{done ? t('progress_done') : t('progress', { checked, total })}</span>
    <div
      class="track"
      role="progressbar"
      aria-valuenow={checked}
      aria-valuemin="0"
      aria-valuemax={total}
    >
      <div class="fill" style:width="{percent}%"></div>
    </div>
  </div>
{/if}

<style>
  .progress {
    margin: var(--space-3) 0 var(--space-4);
  }
  .label {
    display: block;
    margin-bottom: var(--space-2);
    font-size: 14px;
    font-weight: 550;
    color: var(--fg-muted);
  }
  .done .label {
    color: var(--accent);
  }
  .track {
    height: 4px;
    border-radius: 999px;
    background: var(--surface-2);
    overflow: hidden;
  }
  .fill {
    height: 100%;
    border-radius: 999px;
    background: var(--accent);
    transition: width var(--dur) var(--ease);
  }
</style>
